import GenericDB from './generic-db'

export default class UserDashboardDB extends GenericDB {
  constructor() {
    super(`dashboard/`)
  }

  // Here you can extend UserDashboardDB with custom methods
  checking = () => {
    console.log('checking')
  }
}
